module.exports = __webpack_public_path__ + "static/img/animals13.ad8d75da.png";